import React from 'react';

type ILogoProps = {
    className?: string;
};

const LogoPurple = (props: ILogoProps) => {
    return (
        <svg
            width="204"
            height="32"
            viewBox="0 0 204 32"
            fill="none"
            className={props.className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M23.3066 31.3367H29.1845V0H23.3066V31.3367Z" fill="black" />
            <path
                d="M47.2153 20.4642C47.2153 16.3545 44.5641 14.2785 41.6911 14.2785C38.8182 14.2785 36.1669 16.3545 36.1669 20.4642C36.1669 24.5318 38.8182 26.6517 41.6911 26.6517C44.5641 26.6517 47.2153 24.5757 47.2153 20.4642ZM53.0932 20.4642C53.0932 27.139 48.1882 32 41.6911 32C35.194 32 30.2891 27.139 30.2891 20.4642C30.2891 13.7472 35.194 8.93024 41.6911 8.93024C48.1882 8.93024 53.0932 13.7472 53.0932 20.4642Z"
                fill="black"
            />
            <path
                d="M59.4755 20.4642C59.4755 24.398 62.0388 26.6077 65.0437 26.6077C68.0486 26.6077 69.5528 24.6197 70.0384 22.9396L75.209 24.6637C74.2361 28.2879 70.8336 32 65.0437 32C58.6363 32 53.5977 27.139 53.5977 20.4642C53.5977 13.7472 58.5466 8.93024 64.8678 8.93024C70.7896 8.93024 74.1481 12.5984 75.077 16.2665L69.8167 18.0346C69.2871 16.2226 67.9166 14.3665 64.9997 14.3665C61.9948 14.3665 59.4755 16.5322 59.4755 20.4642Z"
                fill="black"
            />
            <path
                d="M88.3771 18.7419L97.2598 31.3367H90.0572L84.3113 23.0275L81.8817 25.5926V31.3367H76.0039V0H81.8817V17.681L89.394 9.59349H97.0839"
                fill="black"
            />
            <path
                d="M114.778 9.59344L119.463 23.6028L123.485 9.59344H129.319L122.512 31.3367H116.634L111.552 16.4882L106.559 31.3367H100.591L93.6543 9.59344H99.84L103.862 23.5588L108.591 9.59344"
                fill="black"
            />
            <path
                d="M144.999 20.4642C144.999 16.3545 142.347 14.2785 139.474 14.2785C136.601 14.2785 133.95 16.3545 133.95 20.4642C133.95 24.5318 136.601 26.6517 139.474 26.6517C142.347 26.6517 144.999 24.5757 144.999 20.4642ZM150.876 20.4642C150.876 27.139 145.971 32 139.474 32C132.977 32 128.072 27.139 128.072 20.4642C128.072 13.7472 132.977 8.93024 139.474 8.93024C145.971 8.93024 150.876 13.7472 150.876 20.4642Z"
                fill="black"
            />
            <path
                d="M165.238 15.4273C164.575 15.2936 164 15.2496 163.47 15.2496C160.465 15.2496 157.856 16.7081 157.856 21.3931V31.3367H151.979V9.59346H157.68V12.82C159.007 9.94708 162.012 9.41577 163.868 9.41577C164.353 9.41577 164.795 9.45975 165.238 9.50374"
                fill="black"
            />
            <path
                d="M178.549 18.7419L187.433 31.3367H180.229L174.485 23.0275L172.054 25.5926V31.3367H166.176V0H172.054V17.681L179.566 9.59349H187.256"
                fill="black"
            />
            <path
                d="M190.878 24.1764C191.01 25.9005 192.291 27.4909 194.855 27.4909C196.8 27.4909 197.727 26.4758 197.727 25.327C197.727 24.3541 197.066 23.5589 195.386 23.2052L192.513 22.542C188.315 21.6148 186.413 19.0955 186.413 16.0449C186.413 12.1568 189.862 8.93024 194.547 8.93024C200.732 8.93024 202.81 12.864 203.076 15.2057L198.171 16.3105C197.993 15.0297 197.066 13.3936 194.591 13.3936C193.042 13.3936 191.806 14.3225 191.806 15.5593C191.806 16.6202 192.601 17.2834 193.794 17.5033L196.888 18.1666C201.176 19.0498 203.341 21.6588 203.341 24.8396C203.341 28.3758 200.6 32 194.899 32C188.359 32 186.105 27.7566 185.84 25.283"
                fill="black"
            />
            <path d="M0 23.5184H7.83419V15.6842H0V23.5184Z" fill="#482AAA" />
            <path d="M0 31.3508H7.83419V23.5184H0V31.3508Z" fill="#5B35D4" />
            <path d="M0 7.85176H7.83419V0.0175781H0V7.85176Z" fill="#231454" />
            <path d="M0 15.6842H7.83419V7.85175H0V15.6842Z" fill="#371F80" />
            <path
                d="M14.4701 0.0756353C14.222 0.0316526 13.9704 0.0175781 13.7189 0.0175781H7.83398V7.85H15.6664V0.388791C15.2794 0.253325 14.88 0.147767 14.4701 0.0756353Z"
                fill="#120A2B"
            />
            <path
                d="M20.9492 7.85001C20.9492 7.83945 20.951 7.82713 20.951 7.81482C20.951 4.37538 18.7413 1.45845 15.666 0.388794V7.85001"
                fill="black"
            />
            <path d="M20.9492 7.85004H15.666V15.2409C18.7307 14.1747 20.9334 11.2736 20.9492 7.85004Z" fill="#120A2B" />
            <path
                d="M7.83398 7.85175V15.6842L13.082 15.6525C14.1956 15.6525 14.8554 15.5241 15.6664 15.2408V7.85175"
                fill="#231454"
            />
            <path
                d="M14.6742 15.6842H14.6882C14.4507 15.6631 14.2115 15.6473 13.9687 15.6473C13.7259 15.6473 7.83398 15.6842 7.83398 15.6842V23.5184H15.6664V15.8408C15.3427 15.7687 15.012 15.7159 14.6742 15.6842Z"
                fill="#371F80"
            />
            <path d="M15.666 15.8408V23.5184H21.8236C21.8236 19.7605 19.1881 16.6219 15.666 15.8408Z" fill="#231454" />
            <path
                d="M7.83398 23.5184V31.3508H14.6742C15.012 31.3209 15.3427 31.2681 15.6664 31.1942V23.5184"
                fill="#482AAA"
            />
            <path d="M15.666 31.196C19.1881 30.4131 21.8236 27.2762 21.8236 23.5184H15.666" fill="#371F80" />
            <path d="M0 23.5184H7.83419V15.6842H0V23.5184Z" fill="#482AAA" />
            <path d="M0 31.3508H7.83419V23.5184H0V31.3508Z" fill="#5B35D4" />
            <path d="M0 7.85176H7.83419V0.0175781H0V7.85176Z" fill="#231454" />
            <path d="M0 15.6842H7.83419V7.85175H0V15.6842Z" fill="#371F80" />
            <path
                d="M14.4701 0.0756353C14.222 0.0316526 13.9704 0.0175781 13.7189 0.0175781H7.83398V7.85H15.6664V0.388791C15.2794 0.253325 14.88 0.147767 14.4701 0.0756353Z"
                fill="#120A2B"
            />
            <path
                d="M20.9492 7.85001C20.9492 7.83945 20.951 7.82713 20.951 7.81482C20.951 4.37538 18.7413 1.45845 15.666 0.388794V7.85001"
                fill="black"
            />
            <path d="M20.9492 7.85004H15.666V15.2409C18.7307 14.1747 20.9334 11.2736 20.9492 7.85004Z" fill="#120A2B" />
            <path
                d="M7.83398 7.85175V15.6842L13.082 15.6525C14.1956 15.6525 14.8554 15.5241 15.6664 15.2408V7.85175"
                fill="#231454"
            />
            <path
                d="M14.6742 15.6842H14.6882C14.4507 15.6631 14.2115 15.6472 13.9687 15.6472C13.7259 15.6472 7.83398 15.6842 7.83398 15.6842V23.5183H15.6664V15.8407C15.3427 15.7686 15.012 15.7158 14.6742 15.6842Z"
                fill="#371F80"
            />
            <path
                d="M7.83398 23.5184V31.3508H14.6742C15.012 31.3209 15.3427 31.2681 15.6664 31.1942V23.5184"
                fill="#482AAA"
            />
            <path d="M15.666 31.196C19.1881 30.4131 21.8236 27.2762 21.8236 23.5184H15.666" fill="#371F80" />
        </svg>
    );
};

export default LogoPurple;
